export default __webpack_public_path__ + "static/media/969 1.2c31f02b.jpg";